// for the role switch (i need to ...) on product page (check, invoice)
export const SWITCH_COMPONENT = 'SWITCH_COMPONENT';
export const SET_POST_TITLE = 'SET_POST_TITLE';

// export const SET_CB_CUSTOMIZATION = 'SET_CB_CUSTOMIZATION';
